import {
  LayoutDashboard,
  MessageSquare,
  Contact,
  MessageSquareText,
  FileText,
  Zap,
  Shield,
  Webhook,
  Users,
  Building2,
  BarChart3,
  Radio,
  ClipboardList,
  Settings,
} from 'lucide-react';

export const navigation = [
  {
    title: 'Workspace',
    items: [
      { label: 'Overview', href: '/', icon: LayoutDashboard },
      { label: 'Conversations', href: '/conversations', icon: MessageSquare },
      { label: 'Contacts', href: '/contacts', icon: Contact },
    ],
  },
  {
    title: 'Knowledge',
    items: [
      { label: 'Saved replies', href: '/canned-responses', icon: MessageSquareText },
      { label: 'Documents', href: '/documents', icon: FileText },
    ],
  },
  {
    title: 'Manage',
    items: [
      { label: 'Automations', href: '/automations', icon: Zap },
      { label: 'SLA policies', href: '/sla-policies', icon: Shield },
      { label: 'Webhooks', href: '/webhooks', icon: Webhook },
      { label: 'Users', href: '/users', icon: Users },
      { label: 'Organizations', href: '/organizations', icon: Building2 },
      { label: 'Analytics', href: '/analytics', icon: BarChart3 },
      { label: 'Channels', href: '/channels', icon: Radio },
      { label: 'Audit log', href: '/audit-log', icon: ClipboardList },
      { label: 'Settings', href: '/settings', icon: Settings },
    ],
  },
];
export function currentPage(pathname: string): string {
  return (
    navigation
      .flatMap((section) => section.items)
      .find((item) =>
        item.href === '/' ? pathname === '/' : pathname === item.href || pathname.startsWith(`${item.href}/`),
      )?.label ?? 'Workspace'
  );
}
